import { createContext } from "react";

export const LayoutContext = createContext({ 
    showMobileNavModal: false, 
    showNotifications: false, 
    isNotificationViewed: false,
    showSideBar: false,  
    showWalletSidebar: false 
});
